import { makeObservable, observable, computed, action } from 'mobx';

import * as JSFUNC from "../../Library/JSFUNC.js";
import * as JSPHP from "../../CaptureExecLocalDatabaseMobx/JSPHP.js";

import DatabaseMobx from '../../CaptureExecLocalDatabaseMobx/DatabaseMobx.js';
import UserMobx from '../../CaptureExecLocalDatabaseMobx/UserMobx.js';

import OpenCaptureMobx from '../OpenCapture/OpenCaptureMobx.js';

class ProposalManagementMobx {
  //========================================================================================
  //observable values
  //Open Capture Proposal Card Tabs
  o_proposalSelectedTabDbName = "proposalThemes"; //"proposalThemes", "proposalManagement"

  //Open Capture Proposal Themes (ocpt_ prefix)
  o_ocptDifferentiatorIDAddingOrEditing = undefined; //undefined neither is open, -1 is adding, id>0 is editing an existing item
  o_ocptWinThemeIDAddingOrEditing = undefined; //undefined neither is open, -1 is adding, id>0 is editing an existing item
  o_ocptGhostThemeIDAddingOrEditing = undefined; //undefined neither is open, -1 is adding, id>0 is editing an existing item
  
  //Open Capture Proposal Management Card (ocpm_ prefix)
  o_ocpmSelectedSubtabDbName = "calendar"; //"calendar", "workAssignments"

  //Admin System Setup - Proposal Management Options tab
  o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName = "proposalThemes"; //"proposalThemes", "proposalManagement"

  //Admin Proposal Management ("apm_" prefix)
  o_apmSelectedSequenceIDOrUndefined = undefined;
  o_apmCalendarPreviewSelectedShowSequenceIDsComma = "";
  o_apmCalendarPreviewDisplayNumWeeks = 5;
  o_apmCalendarPreviewWeekHeight = 6;

  constructor() {
    makeObservable(this, {
      o_proposalSelectedTabDbName: observable,
      o_ocptDifferentiatorIDAddingOrEditing: observable,
      o_ocptWinThemeIDAddingOrEditing: observable,
      o_ocptGhostThemeIDAddingOrEditing: observable,
      o_ocpmSelectedSubtabDbName: observable,
      o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName: observable,
      o_apmSelectedSequenceIDOrUndefined: observable,
      o_apmCalendarPreviewSelectedShowSequenceIDsComma: observable,
      o_apmCalendarPreviewDisplayNumWeeks: observable,
      o_apmCalendarPreviewWeekHeight: observable,

      c_ocptDifferentiatorsArrayOfObjs: computed,
      c_ocptDifferentiatorIDsAlreadyAddedArray: computed,
      c_ocptWinThemesArrayOfObjs: computed,
      c_ocptGhostThemesArrayOfObjs: computed,
      c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj: computed,
      c_ocpmTodayIsPastProposalDueDateTimeUtcTF: computed,
      c_ocpmExpandedProposalObjOrUndefined: computed,
      c_ocpmSelectAdminTurnaroundTimelineTemplateFieldTypeObj: computed,
      c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs: computed,
      c_ocpmSelectWeekHeightEmFieldTypeObj: computed,
      c_ocpmSelectWeekStartDay0To6FieldTypeObj: computed,
      c_aptThemeModulesArrayOfObjs: computed,
      c_aptAllDifferentiatorsArrayOfObjs: computed,
      c_apmSelectCalendarPreviewDisplayNumWeeksFieldTypeObj: computed,
      c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs: computed,
      c_apmAllMilestonesPoolArrayOfObjs: computed,
      c_apmSelectedExpandedSequenceObjOrUndefined: computed,
      c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined: computed,

      a_set_proposal_selected_tab_db_name: action,
      a_ocpt_differentiators_set_id_adding_or_editing: action,
      a_ocpt_win_themes_set_id_adding_or_editing: action,
      a_ocpt_ghost_themes_set_id_adding_or_editing: action,
      a_ocpt_differentiators_insert_new_differentiator: action,
      a_ocpt_differentiators_update_differentiator: action,
      a_ocpt_differentiators_delete_differentiator: action,
      a_ocpt_themes_insert_new_theme: action,
      a_ocpt_themes_update_theme: action,
      a_ocpt_themes_delete_theme: action,
      a_ocpm_insert_proposal: action,
      a_ocpm_delete_proposal: action,
      a_ocpm_insert_new_milestone: action,
      a_ocpm_update_milestone_fields: action,
      a_ocpm_delete_milestone: action,
      a_ocpm_delete_all_calendar_milestones: action,
      a_ocpm_apply_turnaround_template_to_open_proposal: action,
      a_ocpm_set_selected_subtab_db_name: action,
      a_set_admin_setup_tab_proposal_management_options_selected_subtab_db_name: action,
      a_apm_create_new_turnaround_template: action,
      a_apm_update_turnaround_name: action,
      a_apm_delete_turnaround: action,
      a_apm_create_new_sequence: action,
      a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences: action,
      a_apm_update_sequence_field: action,
      a_apm_delete_sequence: action,
      a_apm_add_pool_milestone_to_sequence: action,
      a_apm_update_milestone_field: action,
      a_apm_remove_milestone_from_sequence: action,
      a_apm_remove_all_milestones_matching_milestone_pool_ids_from_sequences: action,
      a_apm_set_calendar_preview_selected_show_sequence_ids_comma: action,
      a_apm_set_calendar_preview_display_num_weeks: action,
      a_apm_set_calendar_preview_week_height: action
    });
  }


  //========================================================================================
  //computed values
  //Open Capture Proposal Themes
  get c_ocptDifferentiatorsArrayOfObjs() {
    const o_openCaptureID = OpenCaptureMobx.o_openCaptureID;
    const o_tbl_c_pt_differentiators = DatabaseMobx.o_tbl_c_pt_differentiators;
    const c_selectAddPTDifferentiatorsFieldTypeObj = DatabaseMobx.c_selectAddPTDifferentiatorsFieldTypeObj;

    //get all differentiators in this open capture, sorted by sort field
    var ptDifferentiatorsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_c_pt_differentiators, "capture_id", o_openCaptureID, "sort", true);
    for(let ptDifferentiatorObj of ptDifferentiatorsArrayOfObjs) {
      ptDifferentiatorObj.differentiatorNameValueMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(ptDifferentiatorObj.differentiator_id, c_selectAddPTDifferentiatorsFieldTypeObj);
    }
    return(ptDifferentiatorsArrayOfObjs);
  }

  get c_ocptDifferentiatorIDsAlreadyAddedArray() {
    const c_ocptDifferentiatorsArrayOfObjs = this.c_ocptDifferentiatorsArrayOfObjs;
    return(JSFUNC.get_column_vector_from_arrayOfObjs(c_ocptDifferentiatorsArrayOfObjs, "differentiator_id"));
  }

  get c_ocptWinThemesArrayOfObjs() {
    const o_openCaptureID = OpenCaptureMobx.o_openCaptureID;
    const o_tbl_c_pt_win_themes = DatabaseMobx.o_tbl_c_pt_win_themes;
    return(JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_c_pt_win_themes, "capture_id", o_openCaptureID, "sort", true));
  }

  get c_ocptGhostThemesArrayOfObjs() {
    const o_openCaptureID = OpenCaptureMobx.o_openCaptureID;
    const o_tbl_c_pt_ghost_themes = DatabaseMobx.o_tbl_c_pt_ghost_themes;
    return(JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_c_pt_ghost_themes, "capture_id", o_openCaptureID, "sort", true));
  }






  //Open Capture Proposal Management
  get c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj() {
    return(DatabaseMobx.capture_field_value_obj_from_capture_map_and_expanded_capture_field_map(OpenCaptureMobx.c_openCaptureMap, DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc));
  }

  get c_ocpmTodayIsPastProposalDueDateTimeUtcTF() {
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const nowDateTimeUtc = JSFUNC.now_naturalDateTimeUtcYmdHis();
    return(nowDateTimeUtc > c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw);
  }

  /*get c_ocpmOpenCaptureProposalDueDateTimeLocalTwoLinesValueMask() {
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    //need too wide datetime to wrap on PropMgmt snapshot card face into 2 lines
  }*/
  
  get c_ocpmExpandedProposalObjOrUndefined() {
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs = this.c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs;
    const o_openCaptureID = OpenCaptureMobx.o_openCaptureID;
    const o_tbl_c_pm_proposals = DatabaseMobx.o_tbl_c_pm_proposals; //either a single row filtered for this capture_id, or 0 rows match
    const o_tbl_c_pm_proposal_milestones = DatabaseMobx.o_tbl_c_pm_proposal_milestones; //all milestones for this capture proposal (already filtered by capture_id when loading open capture data)
    const c_fieldMapOfProposalDueDateTimeUtc = DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc;
    const c_genericStartAndEndDateTimesWithDurationFieldTypeObj = DatabaseMobx.c_genericStartAndEndDateTimesWithDurationFieldTypeObj;
    const c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj = DatabaseMobx.c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj;

    var expandedProposalObjOrUndefined = undefined; //undefined means the proposal row has not been created for this open captureID yet

    const openCaptureProposalMapOrUndefined = JSFUNC.get_first_map_matching_field_value(o_tbl_c_pm_proposals, "capture_id", o_openCaptureID);
    if(openCaptureProposalMapOrUndefined !== undefined) {
      //convert tbl_c_pm_proposals row map as the initial obj before expanding
      var expandedProposalObjOrUndefined = JSFUNC.obj_from_map(openCaptureProposalMapOrUndefined);

      var proposalManagerUserNameMaskSortIfoObj = DatabaseMobx.user_name_mask_sort_ifo_obj_from_user_id(expandedProposalObjOrUndefined.proposal_manager_user_id);
      var proposalManagerAssignmentRequestedTF = (expandedProposalObjOrUndefined.proposal_manager_assignment_requested_01 === 1);

      const proposalDueDateCeDateTimeUtc = c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw;
      const proposalDueDateIsFilledOutTF = c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.isFilledOutTF;
      var proposalDueDateYmd = JSFUNC.blank_date();
      var numDaysFromTodayToProposalDueDate = 0;
      var proposalDueOnDateTimeWithNumDaysString = c_fieldMapOfProposalDueDateTimeUtc.get("display_name") + " is not filled out";
      if(proposalDueDateIsFilledOutTF) {
        proposalDueDateYmd = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(proposalDueDateCeDateTimeUtc); //used to mark proposal due date cell in Calendar
        numDaysFromTodayToProposalDueDate = JSFUNC.num_days_from_date1_to_date2(JSFUNC.now_dateYmd(), proposalDueDateYmd);
        const proposalDueDateDMjYgiA = JSFUNC.get_DMjYgiA_datetime_from_jsdateobj_and_utctf(JSFUNC.convert_ce_datetimeutc_to_jsdateobj(proposalDueDateCeDateTimeUtc));
        proposalDueOnDateTimeWithNumDaysString = "Proposal due on " + proposalDueDateDMjYgiA + " (in " + numDaysFromTodayToProposalDueDate + " days)";
      }

      //get all milestone field display names for the hover text
      const milestoneNameFieldDisplayName = JSFUNC.get_first_obj_value_or_undefined_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", "milestone_name", "fieldDisplayName", "milestone_name");
      const startAndEndDateTimesFieldDisplayName = JSFUNC.get_first_obj_value_or_undefined_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", "startAndEndCeDateTimesUtcSemi", "fieldDisplayName", "startAndEndCeDateTimesUtcSemi");
      const eventLocationFieldDisplayName = JSFUNC.get_first_obj_value_or_undefined_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", "event_location", "fieldDisplayName", "event_location");
      const eventParticipantsUsersFieldDisplayName = JSFUNC.get_first_obj_value_or_undefined_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", "event_participants_user_ids_comma", "fieldDisplayName", "event_participants_user_ids_comma");
      const notesFieldDisplayName = JSFUNC.get_first_obj_value_or_undefined_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", "notes", "fieldDisplayName", "notes");

      var expandedMilestonesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_c_pm_proposal_milestones, "capture_id", expandedProposalObjOrUndefined.capture_id); //double check capture_id filtering
      for(let i = 0; i < expandedMilestonesArrayOfObjs.length; i++) {
        let expandedMilestoneObj = expandedMilestonesArrayOfObjs[i];

        var milestoneDisplayName = ((JSFUNC.string_is_filled_out_tf(expandedMilestoneObj.milestone_name)) ? (expandedMilestoneObj.milestone_name) : ("--Unnamed Milestone--"));
        var milestoneStylingObj = JSFUNC.convert_styling_string_comma_list_to_styling_obj(expandedMilestoneObj.milestone_styling_string_comma);
        var startAndEndCeDateTimesUtcSemi = expandedMilestoneObj.start_ce_datetime_utc + ";" + expandedMilestoneObj.end_ce_datetime_utc;

        var eventHoverText = milestoneNameFieldDisplayName + ": '" + milestoneDisplayName + "'";
        eventHoverText += "\n" + startAndEndDateTimesFieldDisplayName + ": " + DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(startAndEndCeDateTimesUtcSemi, c_genericStartAndEndDateTimesWithDurationFieldTypeObj);
        eventHoverText += "\n\n" + eventLocationFieldDisplayName + ": " + expandedMilestoneObj.event_location;
        eventHoverText += "\n" + eventParticipantsUsersFieldDisplayName + ": " + DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(expandedMilestoneObj.event_participants_user_ids_comma, c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj);
        eventHoverText += "\n\n" + notesFieldDisplayName + ": " + expandedMilestoneObj.notes;
        eventHoverText += "\n\n[Click to edit milestone details]";
        eventHoverText += "\n[Drag left dots to move event, drag right slider to change event duration]";
        
        expandedMilestoneObj.eventName = milestoneDisplayName;
        expandedMilestoneObj.eventHoverText = eventHoverText;
        expandedMilestoneObj.eventBorderHashColor = ((milestoneStylingObj.borderTF) ? ("#" + milestoneStylingObj.borderSelectedColor) : ("#aaabaf"));
        expandedMilestoneObj.eventBackgroundHashColor = ((milestoneStylingObj.highlightTF) ? ("#" + milestoneStylingObj.highlightSelectedColor) : ("#ffffff"));
        expandedMilestoneObj.eventFontHashColor = ((milestoneStylingObj.fontColorTF) ? ("#" + milestoneStylingObj.fontSelectedColor) : (undefined));
        expandedMilestoneObj.eventFontClassString = ((milestoneStylingObj.boldTF) ? ("fontBold") : ("")) + " " + ((milestoneStylingObj.italicTF) ? ("fontItalic") : (""));
        expandedMilestoneObj.startCEDateTimeUtc = expandedMilestoneObj.start_ce_datetime_utc;
        expandedMilestoneObj.endCEDateTimeUtc = expandedMilestoneObj.end_ce_datetime_utc;
      }

      expandedProposalObjOrUndefined.proposalManagerUserNameMaskSortIfoObj = proposalManagerUserNameMaskSortIfoObj;
      expandedProposalObjOrUndefined.proposalManagerAssignmentRequestedTF = proposalManagerAssignmentRequestedTF;
      expandedProposalObjOrUndefined.proposalDueDateIsFilledOutTF = proposalDueDateIsFilledOutTF;
      expandedProposalObjOrUndefined.proposalDueDateCeDateTimeUtc = proposalDueDateCeDateTimeUtc;
      expandedProposalObjOrUndefined.numDaysFromTodayToProposalDueDate = numDaysFromTodayToProposalDueDate;
      expandedProposalObjOrUndefined.proposalDueOnDateTimeWithNumDaysString = proposalDueOnDateTimeWithNumDaysString;
      expandedProposalObjOrUndefined.expandedMilestonesArrayOfObjs = expandedMilestonesArrayOfObjs;
    }
    return(expandedProposalObjOrUndefined);
  }

  get c_ocpmSelectAdminTurnaroundTimelineTemplateFieldTypeObj() {
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;

    const swsOptionsObj = undefined;
    const swsDataObj = DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Proposal Milestones Template", c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs, "id", false, "name", swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", swsDataObj));
  }

  get c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs() {
    const c_genericTextFieldTypeObj = DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericTextareaFieldTypeObj = DatabaseMobx.c_genericTextareaFieldTypeObj;
    const c_genericStartAndEndDateTimesWithDurationFieldTypeObj = DatabaseMobx.c_genericStartAndEndDateTimesWithDurationFieldTypeObj;
    const c_genericStylingStringProposalManagementFieldTypeObj = DatabaseMobx.c_genericStylingStringProposalManagementFieldTypeObj;
    const c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj = DatabaseMobx.c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj;

    const todayDateTimeNoTimeSetUtc = JSFUNC.now_dateYmd() + " 00:00:58";
    const startAndEndDateTimeUtcSemiTodayNoTimeSetString = todayDateTimeNoTimeSetUtc + ";" + todayDateTimeNoTimeSetUtc;

    return([
      {fieldDisplayName:"Milestone Name",           fieldDbName:"milestone_name",                     fieldTypeObj:c_genericTextFieldTypeObj,                             valueRaw:undefined,                                       requiredNotEmptyTF:true},
      {fieldDisplayName:"Milestone Styling",        fieldDbName:"milestone_styling_string_comma",     fieldTypeObj:c_genericStylingStringProposalManagementFieldTypeObj,  valueRaw:undefined},
      {fieldDisplayName:"Start and End Dates/Times", fieldDbName:"startAndEndCeDateTimesUtcSemi",     fieldTypeObj:c_genericStartAndEndDateTimesWithDurationFieldTypeObj, valueRaw:startAndEndDateTimeUtcSemiTodayNoTimeSetString,  requiredNotEmptyTF:true},
      {fieldDisplayName:"Event Location",           fieldDbName:"event_location",                     fieldTypeObj:c_genericTextFieldTypeObj,                             valueRaw:undefined},
      {fieldDisplayName:"Event Participants",       fieldDbName:"event_participants_user_ids_comma",  fieldTypeObj:c_selectMultiUsersDeactivatedHiddenUnlessCheckedFieldTypeObj,                        valueRaw:undefined},
      {fieldDisplayName:"Notes",                    fieldDbName:"notes",                              fieldTypeObj:c_genericTextareaFieldTypeObj,                         valueRaw:undefined,                                       heightEm:6}
    ]);
  }

  get c_ocpmSelectWeekHeightEmFieldTypeObj() {
    const intWeekHeightsArray = JSFUNC.array_fill_incrementing_x_to_y(3, 50, 1);
    const weekHeightValueArray = JSFUNC.concat_arrays_or_values_into_new_array(1, intWeekHeightsArray);
    const weekHeightDisplayArray = JSFUNC.concat_arrays_or_values_into_new_array("Auto", intWeekHeightsArray);
    const swsOptionsObj = undefined;
    const swsDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Week Height", weekHeightValueArray, false, weekHeightDisplayArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", swsDataObj));
  }
  
  get c_ocpmSelectWeekStartDay0To6FieldTypeObj() {
    const weekStartDayDisplayArray = JSFUNC.all_7_day_full_names_starting_sunday_array();
    const weekStartDayValueArray = JSFUNC.array_fill_incrementing_0_to_nm1(weekStartDayDisplayArray.length);
    const swsOptionsObj = undefined;
    const swsDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Week Start Day", weekStartDayValueArray, false, weekStartDayDisplayArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", swsDataObj));
  }




  

  //Admin Proposal Themes
  get c_aptThemeModulesArrayOfObjs() {
    const c_companyUsingPTDifferentiatorsTF = DatabaseMobx.c_companyUsingPTDifferentiatorsTF;
    const c_companyUsingPTWinThemesTF = DatabaseMobx.c_companyUsingPTWinThemesTF;
    const c_companyUsingPTGhostThemesTF = DatabaseMobx.c_companyUsingPTGhostThemesTF;

    return([
      {
        moduleName: "Differentiators",
        singleItemName: "Differentiator",
        pluralItemsName: "Differentiators",
        isDifferentiatorsTF: true,
        isWinThemesTF: false,
        isGhostThemesTF: false,
        adminSwitchTblCompanyColumnDbName: "pt_differentiators_01",
        headerDarkBgColor: "446699",
        middleFontColor: "aabbcc",
        bodyLightBgColor: "dde6fc",
        usingModuleTF: c_companyUsingPTDifferentiatorsTF
      },
      {
        moduleName: "Win Themes",
        singleItemName: "Win Theme",
        pluralItemsName: "Win Themes",
        isDifferentiatorsTF: false,
        isWinThemesTF: true,
        isGhostThemesTF: false,
        adminSwitchTblCompanyColumnDbName: "pt_win_themes_01",
        headerDarkBgColor: "998855",
        middleFontColor: "ccbb88",
        bodyLightBgColor: "faf8e0",
        usingModuleTF: c_companyUsingPTWinThemesTF
      },
      {
        moduleName: "Ghost Themes",
        singleItemName: "Ghost Theme",
        pluralItemsName: "Ghost Themes",
        isDifferentiatorsTF: false,
        isWinThemesTF: false,
        isGhostThemesTF: true,
        adminSwitchTblCompanyColumnDbName: "pt_ghost_themes_01",
        headerDarkBgColor: "777777",
        middleFontColor: "afafaf",
        bodyLightBgColor: "f3f3f3",
        usingModuleTF: c_companyUsingPTGhostThemesTF
      }
    ]);
  }
  

  get c_aptAllDifferentiatorsArrayOfObjs() {
    return(JSFUNC.arrayOfObjs_from_mapOfMaps(DatabaseMobx.o_tbl_a_pt_differentiators, "name", true));
  }
  

  get c_apmSelectCalendarPreviewDisplayNumWeeksFieldTypeObj() {
    const displayNumWeeksArray = JSFUNC.array_fill_incrementing_x_to_y(1, 20, 1);
    const swsOptionsObj = undefined;
    const swsDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Display # Weeks", displayNumWeeksArray, false, displayNumWeeksArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", swsDataObj));
  }





  //Admin Proposal Management
  get c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs() {
    /*tbl_a_pm_all_milestones_pool:         ["id", "admin_sort", "name", "calendar_styling_string_comma"],
    tbl_a_pm_milestones:                    ["id", "proposal_sequence_id", "proposal_milestone_pool_id", "initial_num_days_prior_to_proposal_due_date", "initial_duration_num_days"],
    tbl_a_pm_sequences:                     ["id", "sort", "proposal_turnaround_timeline_template_id", "name", "sequence_bg_color"],
    tbl_a_pm_turnaround_timeline_templates: ["id", "admin_sort", "name"],*/
    const o_tbl_a_pm_all_milestones_pool = DatabaseMobx.o_tbl_a_pm_all_milestones_pool;
    const o_tbl_a_pm_milestones = DatabaseMobx.o_tbl_a_pm_milestones;
    const o_tbl_a_pm_sequences = DatabaseMobx.o_tbl_a_pm_sequences;
    const o_tbl_a_pm_turnaround_timeline_templates = DatabaseMobx.o_tbl_a_pm_turnaround_timeline_templates;

    //&&& 1. turnarounds &&&&&&&&&&&&&&&&&&&&&&&&&&&&
    var proposalManagementAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = [];
    for(let tblAPropsoalTurnaroundTimelineTemplateMap of o_tbl_a_pm_turnaround_timeline_templates.values()) {
      var expandedTurnaroundObj = JSFUNC.obj_from_map(tblAPropsoalTurnaroundTimelineTemplateMap);

      var allSequencesMinNumDaysPrior = 0;
      var allSequencesMaxNumDaysPrior = 0;

      //=== 2. sequences ==============================
      var expandedSequencesArrayOfObjs = [];
      for(let tblAProposalMilestoneSequenceMap of o_tbl_a_pm_sequences.values()) {
        if(tblAProposalMilestoneSequenceMap.get("proposal_turnaround_timeline_template_id") === expandedTurnaroundObj.id) {
          var expandedSequenceObj = JSFUNC.obj_from_map(tblAProposalMilestoneSequenceMap);
          
          //--- 3. milestones --------------------------
          var expandedMilestonesArrayOfObjs = [];
          for(let tblAPropsoalMilestoneMap of o_tbl_a_pm_milestones.values()) {
            if(tblAPropsoalMilestoneMap.get("proposal_sequence_id") === expandedSequenceObj.id) {
              var expandedMilestoneObj = JSFUNC.obj_from_map(tblAPropsoalMilestoneMap);

              //pool milestone from `proposal_milestone_pool_id` (fetch row map from ID, or creates a --Does Not Exist-- version if the ID can't be found)
              var tblAProposalAllMilestonesPoolRowMapOrUndefined = o_tbl_a_pm_all_milestones_pool.get(expandedMilestoneObj.proposal_milestone_pool_id);
              if(tblAProposalAllMilestonesPoolRowMapOrUndefined === undefined) {
                tblAProposalAllMilestonesPoolRowMapOrUndefined = DatabaseMobx.does_not_exist_tbl_row_map_from_tbl_name("tbl_a_pm_all_milestones_pool", "id", expandedMilestoneObj.proposal_milestone_pool_id);
              }

              //copy all pool milestone fields into the original milestone obj
              for(let [key, value] of tblAProposalAllMilestonesPoolRowMapOrUndefined) {
                if(key === "id") {
                  expandedMilestoneObj["allMilestonesPoolID"] = value; //change "id" fieldName from pool to allMilestonesPoolID since in this obj "id" is already the unique ID within tbl_a_pm_milestones
                }
                else {
                  expandedMilestoneObj[key] = value;
                }
              }

              var milestoneStylingObj = JSFUNC.convert_styling_string_comma_list_to_styling_obj(expandedMilestoneObj.calendar_styling_string_comma);

              var calSeqBoldTF = false;
              var calSeqItalicTF = false;
              var calSeqFontColor = "333333";
              var calSeqBgColor = "ffffff";
              var calSeqBorderColor = expandedSequenceObj.sequence_bg_color;
              if(milestoneStylingObj.anyStylingAppliedTF) {
                calSeqBoldTF = milestoneStylingObj.boldTF;

                calSeqItalicTF = milestoneStylingObj.italicTF;

                if(milestoneStylingObj.fontColorTF) {
                  calSeqFontColor = milestoneStylingObj.fontSelectedColor;
                }

                if(milestoneStylingObj.highlightTF) {
                  calSeqBgColor = milestoneStylingObj.highlightSelectedColor;
                }

                if(milestoneStylingObj.borderTF) {
                  calSeqBorderColor = milestoneStylingObj.borderSelectedColor;
                }
              }

              var milestoneHoverText = "Milestone: '" + expandedMilestoneObj.name + "'";
              milestoneHoverText += "\n" + "# Days Prior To Proposal Due Date: " + expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date;
              milestoneHoverText += "\n" + "Duration (# Days): " + expandedMilestoneObj.initial_duration_num_days;
              milestoneHoverText += "\n\n" + "Turnaround Template: '" + expandedTurnaroundObj.name + "'";
              milestoneHoverText += "\n" + "Sequence: '" + expandedSequenceObj.name + "'";

              expandedMilestoneObj.milestoneDisplayName = ((JSFUNC.string_is_filled_out_tf(expandedMilestoneObj.name)) ? (expandedMilestoneObj.name) : ("--Unnamed Milestone--"));
              expandedMilestoneObj.milestoneStylingObj = milestoneStylingObj;
              expandedMilestoneObj.calSeqBorderColor = calSeqBorderColor;
              expandedMilestoneObj.calSeqBgColor = calSeqBgColor;
              expandedMilestoneObj.calSeqFontClassString = ((calSeqBoldTF) ? ("fontBold") : ("")) + " " + ((calSeqItalicTF) ? ("fontItalic") : (""));
              expandedMilestoneObj.calSeqFontColor = calSeqFontColor;
              expandedMilestoneObj.milestoneHoverText = milestoneHoverText;

              expandedMilestonesArrayOfObjs.push(expandedMilestoneObj);

              //compute looping stats for each milestone across all sequences in this turnaround
              if(expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date < allSequencesMinNumDaysPrior) {
                allSequencesMinNumDaysPrior = (expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date - expandedMilestoneObj.initial_duration_num_days); //prior # days minus duration gets the latest end date for the milestone
              }

              if(expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date > allSequencesMaxNumDaysPrior) {
                allSequencesMaxNumDaysPrior = expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date; //since this is the earliest start date for the milestone, we don't need to factor in duration here like we do for the min num days prior calculation
              }
            }
          }
          JSFUNC.sort_arrayOfObjs(expandedMilestonesArrayOfObjs, "initial_num_days_prior_to_proposal_due_date", false);
          //--------------------------------------------

          var numMilestones = expandedMilestonesArrayOfObjs.length;
          var milestoneIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(expandedMilestonesArrayOfObjs, "id");
          var poolMilestoneIDsAddedArray = JSFUNC.get_column_vector_from_arrayOfObjs(expandedMilestonesArrayOfObjs, "proposal_milestone_pool_id");

          //loop through milestones now that they are sorted by num days prior
          var milestoneNamesWithNumDaysPriorStringsArray = [];
          var milestoneNamesWithNumDaysPriorAndDurationStringsArray = [];
          var sequenceHoverText = "Turnaround Template: '" + expandedTurnaroundObj.name + "'";
          sequenceHoverText += "\n" + "Sequence: '" + expandedSequenceObj.name + "'";
          sequenceHoverText += "\n" + "Milestones (" + numMilestones + "):";
          for(let expandedMilestoneObj of expandedMilestonesArrayOfObjs) {
            milestoneNamesWithNumDaysPriorStringsArray.push(expandedMilestoneObj.name + " (" + expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date + " " + JSFUNC.plural(expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date, "day", "days") + " prior)");
            milestoneNamesWithNumDaysPriorAndDurationStringsArray.push(expandedMilestoneObj.name + " (" + expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date + " " + JSFUNC.plural(expandedMilestoneObj.initial_num_days_prior_to_proposal_due_date, "day", "days") + " prior duration " + expandedMilestoneObj.initial_duration_num_days + " " + JSFUNC.plural(expandedMilestoneObj.initial_duration_num_days, "day", "days") + ")");
            sequenceHoverText += "\n" + " - " + expandedMilestoneObj.name;
          }

          expandedSequenceObj.sequenceDisplayName = ((JSFUNC.string_is_filled_out_tf(expandedSequenceObj.name)) ? (expandedSequenceObj.name) : ("--Unnamed Sequence--"));
          expandedSequenceObj.sequenceHoverText = sequenceHoverText;
          expandedSequenceObj.expandedMilestonesArrayOfObjs = expandedMilestonesArrayOfObjs;
          expandedSequenceObj.numMilestones = numMilestones;
          expandedSequenceObj.milestoneIDsArray = milestoneIDsArray;
          expandedSequenceObj.milestoneNamesWithNumDaysPriorStringsArray = milestoneNamesWithNumDaysPriorStringsArray;
          expandedSequenceObj.milestoneNamesWithNumDaysPriorAndDurationStringsArray = milestoneNamesWithNumDaysPriorAndDurationStringsArray;
          expandedSequenceObj.poolMilestoneIDsAddedArray = poolMilestoneIDsAddedArray;

          expandedSequencesArrayOfObjs.push(expandedSequenceObj);
        }
      }
      JSFUNC.sort_arrayOfObjs(expandedSequencesArrayOfObjs, "sort", true);
      //==============================================

      var numSequences = expandedSequencesArrayOfObjs.length;

      var sequenceIDsArray = JSFUNC.get_column_vector_from_arrayOfObjs(expandedSequencesArrayOfObjs, "id");

      var allSequencesMilestoneIDsArray = [];
      var turnaroundHoverText = "Turnaround Template: '" + expandedTurnaroundObj.name + "'";
      for(let expandedSequenceObj of expandedSequencesArrayOfObjs) {
        allSequencesMilestoneIDsArray = JSFUNC.concat_arrays_or_values_into_new_array(allSequencesMilestoneIDsArray, expandedSequenceObj.milestoneIDsArray);
        turnaroundHoverText += "\n\n" + "[Sequence: '" + expandedSequenceObj.name + "']";
        for(let milestoneNameWithNumDaysPriorAndDurationString of expandedSequenceObj.milestoneNamesWithNumDaysPriorAndDurationStringsArray) {
          turnaroundHoverText += "\n - " + milestoneNameWithNumDaysPriorAndDurationString;
        }
      }

      var allSequencesAllMilestoneNamesWithNumDaysPriorString = "--No Sequences/Milestones in Template '" + expandedTurnaroundObj.name + "'--";
      if(numSequences > 0) {
        allSequencesAllMilestoneNamesWithNumDaysPriorString = "";
        for(let expandedSequenceObj of expandedSequencesArrayOfObjs) {
          if(JSFUNC.is_array_not_empty(expandedSequenceObj.milestoneNamesWithNumDaysPriorStringsArray)) {
            allSequencesAllMilestoneNamesWithNumDaysPriorString += "[" + expandedSequenceObj.milestoneNamesWithNumDaysPriorStringsArray.join(", ") + "] ";
          }
        }
      }
      
      expandedTurnaroundObj.expandedSequencesArrayOfObjs = expandedSequencesArrayOfObjs;
      expandedTurnaroundObj.numSequences = numSequences;
      expandedTurnaroundObj.sequenceIDsArray = sequenceIDsArray;
      expandedTurnaroundObj.allSequencesMilestoneIDsArray = allSequencesMilestoneIDsArray;
      expandedTurnaroundObj.allSequencesMinNumDaysPrior = allSequencesMinNumDaysPrior;
      expandedTurnaroundObj.allSequencesMaxNumDaysPrior = allSequencesMaxNumDaysPrior;
      expandedTurnaroundObj.allSequencesAllMilestoneNamesWithNumDaysPriorString = allSequencesAllMilestoneNamesWithNumDaysPriorString;
      expandedTurnaroundObj.turnaroundHoverText = turnaroundHoverText;

      proposalManagementAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs.push(expandedTurnaroundObj);
    }
    JSFUNC.sort_arrayOfObjs(proposalManagementAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs, "admin_sort", true);

    //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
    return(proposalManagementAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs);
  }


  get c_apmAllMilestonesPoolArrayOfObjs() {
    const o_tbl_a_pm_all_milestones_pool = DatabaseMobx.o_tbl_a_pm_all_milestones_pool;
    return(JSFUNC.arrayOfObjs_from_mapOfMaps(o_tbl_a_pm_all_milestones_pool, "admin_sort", true));
  }


  get c_apmSelectedExpandedSequenceObjOrUndefined() {
    const o_apmSelectedSequenceIDOrUndefined = this.o_apmSelectedSequenceIDOrUndefined;
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;

    if(JSFUNC.is_number_not_nan_gt_0(o_apmSelectedSequenceIDOrUndefined)) { //no need to check if no sequenceID is selected
      if(JSFUNC.is_array(c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs)) {
        for(let expandedTurnaroundObj of c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs) { //loop through all turnarounds
          if(JSFUNC.is_array_not_empty(expandedTurnaroundObj.expandedSequencesArrayOfObjs)) {
            for(let expandedSequenceObj of expandedTurnaroundObj.expandedSequencesArrayOfObjs) {
              if(expandedSequenceObj.id === o_apmSelectedSequenceIDOrUndefined) {
                return(expandedSequenceObj);
              }
            }
          }
        }
      }
    }
    return(undefined);
  }

  get c_apmExpandedTurnaroundObjContainingSelectedSequenceOrUndefined() {
    const o_apmSelectedSequenceIDOrUndefined = this.o_apmSelectedSequenceIDOrUndefined;
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;

    for(let expandedTurnaroundObj of c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs) {
      if(JSFUNC.in_array(o_apmSelectedSequenceIDOrUndefined, expandedTurnaroundObj.sequenceIDsArray)) {
        return(expandedTurnaroundObj);
      }
    }
    return(undefined);
  }





  //========================================================================================
  //action methods
  //Open Capture Proposal Card Tabs
  a_set_proposal_selected_tab_db_name(i_tabDbName) {
    this.o_proposalSelectedTabDbName = i_tabDbName;
  }


  

  //Open Capture Proposal Themes Card
  a_ocpt_differentiators_set_id_adding_or_editing(i_idAddingOrEditing) {
    this.o_ocptDifferentiatorIDAddingOrEditing = i_idAddingOrEditing;
  }
  a_ocpt_win_themes_set_id_adding_or_editing(i_idAddingOrEditing) {
    this.o_ocptWinThemeIDAddingOrEditing = i_idAddingOrEditing;
  }
  a_ocpt_ghost_themes_set_id_adding_or_editing(i_idAddingOrEditing) {
    this.o_ocptGhostThemeIDAddingOrEditing = i_idAddingOrEditing;
  }

  a_ocpt_differentiators_insert_new_differentiator(i_captureID, i_differentiator, i_justification) {
    const numExistingCaptureDifferentiators = this.c_ocptDifferentiatorsArrayOfObjs.length;

    var fieldNamesArray = ["capture_id", "sort", "differentiator_id", "justification"];
    var valuesArray = [i_captureID, (numExistingCaptureDifferentiators + 1), i_differentiator, i_justification];
    var valuesIdsbArray = ["i", "i", "i", "s"];

    const differentiatorNameMaskPlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(i_differentiator, DatabaseMobx.c_selectAddPTDifferentiatorsFieldTypeObj);
    const insertDifferentiatorChangeLogString = "Differentiator: '" + differentiatorNameMaskPlainText + "', Justification: '" + i_justification + "'";

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_differentiators_insert_new_differentiator", ["i_captureID", "i_differentiator", "i_justification"], [i_captureID, i_differentiator, i_justification]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_insert("tbl_c_pt_differentiators", fieldNamesArray, valuesArray, valuesIdsbArray);
    C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "and", "Add New Differentiator", insertDifferentiatorChangeLogString);
    C_CallPhpTblUID.execute();
  }

  a_ocpt_differentiators_update_differentiator(i_captureID, i_differentiatorID, i_differentiator, i_justification) {
    var fieldNamesArray = [];
    var valuesArray = [];
    var valuesIdsbArray = [];
    var updateDifferentiatorChangeLogArray = [];

    if(i_differentiator !== undefined) {
      fieldNamesArray.push("differentiator_id");
      valuesArray.push(i_differentiator);
      valuesIdsbArray.push("i");

      const differentiatorNameMaskPlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(i_differentiator, DatabaseMobx.c_selectAddPTDifferentiatorsFieldTypeObj);
      updateDifferentiatorChangeLogArray.push("Differentiator: '" + differentiatorNameMaskPlainText);
    }

    if(i_justification !== undefined) {
      fieldNamesArray.push("justification");
      valuesArray.push(i_justification);
      valuesIdsbArray.push("s");
      updateDifferentiatorChangeLogArray.push("Justification: '" + i_justification);
    }

    if(fieldNamesArray.length > 0) { //if none of the fields have been changed, do not do an update/changelog operation
      const  updateDifferentiatorChangeLogString = updateDifferentiatorChangeLogArray.join(", ");

      const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_differentiators_update_differentiator", ["i_captureID", "i_differentiatorID", "i_differentiator", "i_justification"], [i_captureID, i_differentiatorID, i_differentiator, i_justification]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update("tbl_c_pt_differentiators", i_differentiatorID, fieldNamesArray, valuesArray, valuesIdsbArray);
      C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "ud", "Update Differentiator", updateDifferentiatorChangeLogString);
      C_CallPhpTblUID.execute();
    }
  }

  a_ocpt_differentiators_delete_differentiator(i_captureID, i_differentiatorObj) {
    const deleteDifferentiatorChangeLogString = "Differentiator: '" + i_differentiatorObj.differentiatorNameValueMaskSortIfoObj.valueMaskPlainText + "', Justification: '" + i_differentiatorObj.justification + "'";

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_differentiators_delete_differentiator", ["i_captureID", "i_differentiatorObj"], [i_captureID, i_differentiatorObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_c_pt_differentiators", i_differentiatorObj.id, "sort", "capture_id", i_captureID);
    C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "rd", "Remove Differentiator", deleteDifferentiatorChangeLogString);
    C_CallPhpTblUID.execute();
  }

  a_ocpt_themes_insert_new_theme(i_captureID, i_winTrueGhostFalse, i_theme, i_justification) {
    const themesArrayOfObjs = ((i_winTrueGhostFalse) ? (this.c_ocptWinThemesArrayOfObjs) : (this.c_ocptGhostThemesArrayOfObjs));
    const numExistingCaptureThemes = themesArrayOfObjs.length;
    const tblName = ((i_winTrueGhostFalse) ? ("tbl_c_pt_win_themes") : ("tbl_c_pt_ghost_themes"));

    var fieldNamesArray = ["capture_id", "sort", "theme", "justification"];
    var valuesArray = [i_captureID, (numExistingCaptureThemes + 1), i_theme, i_justification];
    var valuesIdsbArray = ["i", "i", "s", "s"];

    const insertThemeChangeLogString = "Theme: '" + i_theme + "', Justification: '" + i_justification + "'";

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_themes_insert_new_theme", ["i_captureID", "i_theme", "i_justification"], [i_captureID, i_theme, i_justification]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_insert(tblName, fieldNamesArray, valuesArray, valuesIdsbArray);
    C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "ant", "Add New Theme", insertThemeChangeLogString);
    C_CallPhpTblUID.execute();
  }

  a_ocpt_themes_update_theme(i_captureID, i_winTrueGhostFalse, i_themeID, i_theme, i_justification) {
    const tblName = ((i_winTrueGhostFalse) ? ("tbl_c_pt_win_themes") : ("tbl_c_pt_ghost_themes"));

    var fieldNamesArray = [];
    var valuesArray = [];
    var valuesIdsbArray = [];
    var updateThemeChangeLogArray = [];

    if(i_theme !== undefined) {
      fieldNamesArray.push("theme");
      valuesArray.push(i_theme);
      valuesIdsbArray.push("s");
      updateThemeChangeLogArray.push("Theme: '" + i_theme);
    }

    if(i_justification !== undefined) {
      fieldNamesArray.push("justification");
      valuesArray.push(i_justification);
      valuesIdsbArray.push("s");
      updateThemeChangeLogArray.push("Justification: '" + i_justification);
    }

    if(fieldNamesArray.length > 0) { //if none of the fields have been changed, do not do an update/changelog operation
      const  updateThemeChangeLogString = updateThemeChangeLogArray.join(", ");

      const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_themes_update_theme", ["i_captureID", "i_themeID", "i_theme", "i_justification"], [i_captureID, i_themeID, i_theme, i_justification]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update(tblName, i_themeID, fieldNamesArray, valuesArray, valuesIdsbArray);
      C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "ut", "Update Theme", updateThemeChangeLogString);
      C_CallPhpTblUID.execute();
    }
  }

  a_ocpt_themes_delete_theme(i_captureID, i_winTrueGhostFalse, i_themeObj) {
    const tblName = ((i_winTrueGhostFalse) ? ("tbl_c_pt_win_themes") : ("tbl_c_pt_ghost_themes"));
    const deleteThemeChangeLogString = "Theme: '" + i_themeObj.theme + "', Justification: '" + i_themeObj.justification + "'";

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpt_themes_delete_theme", ["i_captureID", "i_themeObj"], [i_captureID, i_themeObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete(tblName, i_themeObj.id, "sort", "capture_id", i_captureID);
    C_CallPhpTblUID.add_changelog_details(i_captureID, DatabaseMobx.k_cardIDProposalManagement, "rt", "Remove Theme", deleteThemeChangeLogString);
    C_CallPhpTblUID.execute();
  }








  //Open Capture Proposal Management Card/Tab
  a_ocpm_insert_proposal(i_proposalManagerUserID, i_proposalManagerAssignmentRequestedTF) {
    const o_openCaptureID = OpenCaptureMobx.o_openCaptureID;
    const c_openCaptureMap = OpenCaptureMobx.c_openCaptureMap;
    const c_fieldMapOfProposalManager = DatabaseMobx.c_fieldMapOfProposalManager;
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;

    if(JSFUNC.select_int_is_filled_out_tf(i_proposalManagerUserID)) {
      const sendNotificationTF = false;
      OpenCaptureMobx.a_details_update_field_value(c_fieldMapOfProposalManager, i_proposalManagerUserID, c_openCaptureMap, k_cardIDProposalManagement, sendNotificationTF);
    }

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_insert_proposal", ["i_proposalManagerUserID", "i_proposalManagerAssignmentRequestedTF"], [i_proposalManagerUserID, i_proposalManagerAssignmentRequestedTF]);
    const C_CallPhpTblUIDInsertProposal = new JSPHP.ClassCallPhpTblUID(jsDescription);
    const fieldDbNamesArray = ["capture_id", "proposal_manager_assignment_requested_01"];
    const valuesArray = [o_openCaptureID, ((i_proposalManagerAssignmentRequestedTF) ? (1) : (0))];
    const idsbArray = ["i", "i"];
    C_CallPhpTblUIDInsertProposal.add_insert("tbl_c_pm_proposals", fieldDbNamesArray, valuesArray, idsbArray);
    C_CallPhpTblUIDInsertProposal.add_changelog_details(o_openCaptureID, k_cardIDProposalManagement, "ip", "Insert Proposal", "Started proposal management for this capture");
    C_CallPhpTblUIDInsertProposal.execute();
  }

  a_ocpm_delete_proposal(i_expandedProposalObj) {
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_delete_proposal", ["i_expandedProposalObj"], [i_expandedProposalObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_c_pm_proposals", i_expandedProposalObj.id);
    C_CallPhpTblUID.add_changelog_details(i_expandedProposalObj.capture_id, k_cardIDProposalManagement, "dp", "Delete Proposal", "Deleted proposal process from capture");
    C_CallPhpTblUID.execute();
  }

  a_ocpm_insert_new_milestone(i_expandedProposalObj, i_newMilestonefieldDbNamesValuesObj) {
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_insert_new_milestone", ["i_expandedProposalObj", "i_newMilestonefieldDbNamesValuesObj"], [i_expandedProposalObj, i_newMilestonefieldDbNamesValuesObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const captureID = i_expandedProposalObj.capture_id; //get capture_id from the expandedProposalObj, not the milestone fields/values obj

    var startDateTimeUtc = JSFUNC.blank_datetime();
    var endDateTimeUtc = JSFUNC.blank_datetime();
    var startAndEndCeDateTimesArray = [];
    if(JSFUNC.is_string_not_empty(i_newMilestonefieldDbNamesValuesObj.startAndEndCeDateTimesUtcSemi)) {
      startAndEndCeDateTimesArray = i_newMilestonefieldDbNamesValuesObj.startAndEndCeDateTimesUtcSemi.split(";");
    }

    if(startAndEndCeDateTimesArray.length === 2) {
     startDateTimeUtc = startAndEndCeDateTimesArray[0];
     endDateTimeUtc = startAndEndCeDateTimesArray[1];
    }

    const fieldDbNamesArray = ["capture_id", "milestone_name", "milestone_styling_string_comma", "start_ce_datetime_utc", "end_ce_datetime_utc", "event_location", "event_participants_user_ids_comma", "notes"];
    const valuesArray = [captureID, i_newMilestonefieldDbNamesValuesObj.milestone_name, i_newMilestonefieldDbNamesValuesObj.milestone_styling_string_comma, startDateTimeUtc, endDateTimeUtc, i_newMilestonefieldDbNamesValuesObj.event_location, i_newMilestonefieldDbNamesValuesObj.event_participants_user_ids_comma, i_newMilestonefieldDbNamesValuesObj.notes];
    const idsbArray = ["i", "s", "s", "s", "s", "s", "s", "s"];
    C_CallPhpTblUID.add_insert("tbl_c_pm_proposal_milestones", fieldDbNamesArray, valuesArray, idsbArray);
    
    C_CallPhpTblUID.add_changelog_details(i_expandedProposalObj.capture_id, k_cardIDProposalManagement, "im", "Insert Milestone", "Inserted new Proposal Milestone: '" + i_newMilestonefieldDbNamesValuesObj.milestone_name + "'");

    C_CallPhpTblUID.execute();
  }

  a_ocpm_update_milestone_fields(i_expandedMilestoneObj, i_fieldDbNamesArray, i_newValuesArray) {
    const c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs = this.c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs;
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;
    const c_genericDateTimeFieldTypeObj = DatabaseMobx.c_genericDateTimeFieldTypeObj;

    const fieldDbNamesArray = JSFUNC.convert_single_or_array_to_array(i_fieldDbNamesArray);
    const newValuesArray = JSFUNC.convert_single_or_array_to_array(i_newValuesArray);
    const numInputFields = fieldDbNamesArray.length;

    if((numInputFields === 0) || (newValuesArray.length !== numInputFields)) {
      return;
    }
    
    const startDateTimeFieldDbName = "start_ce_datetime_utc";
    const endDateTimeFieldDbName = "end_ce_datetime_utc";
    const startDateTimeFieldDisplayName = "Start Date/Time";
    const endDateTimeFieldDisplayName = "End Date/Time";

    var updateFieldDbNamesArray = [];
    var updateNewValuesArray = [];
    var updateFieldDisplayNamesArray = [];
    var updateFieldTypeObjsArray = [];
    for(let f = 0; f < numInputFields; f++) {
      const fieldDbName = fieldDbNamesArray[f];
      const newValue = newValuesArray[f];

      var fieldIsStartDateTimeTF = false;
      var fieldIsEndDateTimeTF = false;
      var fieldIsStartAndEndDateTimeSemiTF = false;
      if(fieldDbName === startDateTimeFieldDbName) { fieldIsStartDateTimeTF = true; }
      else if(fieldDbName === endDateTimeFieldDbName) { fieldIsEndDateTimeTF = true; }
      else if(fieldDbName === "startAndEndCeDateTimesUtcSemi") { fieldIsStartAndEndDateTimeSemiTF = true; }

      if(fieldIsStartAndEndDateTimeSemiTF) {
        var startAndEndCeDateTimesArray = [];
        if(JSFUNC.is_string_not_empty(newValue)) {
          startAndEndCeDateTimesArray = newValue.split(";");
        }

        if(startAndEndCeDateTimesArray.length === 2) {
          updateFieldDbNamesArray.push(startDateTimeFieldDbName, endDateTimeFieldDbName);
          updateNewValuesArray.push(startAndEndCeDateTimesArray[0], startAndEndCeDateTimesArray[1]);
          updateFieldDisplayNamesArray.push(startDateTimeFieldDisplayName, endDateTimeFieldDisplayName);
          updateFieldTypeObjsArray.push(c_genericDateTimeFieldTypeObj, c_genericDateTimeFieldTypeObj);
        }
      }
      else {
        if(fieldIsStartDateTimeTF || fieldIsEndDateTimeTF) {
          updateFieldDbNamesArray.push(fieldDbName);
          updateNewValuesArray.push(newValue);
          updateFieldDisplayNamesArray.push((fieldIsStartDateTimeTF ? startDateTimeFieldDisplayName : endDateTimeFieldDisplayName));
          updateFieldTypeObjsArray.push(c_genericDateTimeFieldTypeObj);
        }
        else {
          var matchingIefFieldObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(c_ocpmCreateNewMilestoneIefFieldsArrayOfObjs, "fieldDbName", fieldDbName);
          if(matchingIefFieldObjOrUndefined !== undefined) {
            updateFieldDbNamesArray.push(fieldDbName);
            updateNewValuesArray.push(newValue);
            updateFieldDisplayNamesArray.push(matchingIefFieldObjOrUndefined.fieldDisplayName);
            updateFieldTypeObjsArray.push(matchingIefFieldObjOrUndefined.fieldTypeObj);
          }
        }
      }
    }

    const numFieldsToUpdate = updateFieldDbNamesArray.length;
    if(numFieldsToUpdate === 0) {
      return;
    }

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_update_milestone_fields", ["i_expandedMilestoneObj", "i_fieldDbNamesArray", "i_newValuesArray"], [i_expandedMilestoneObj, updateFieldDbNamesArray, updateNewValuesArray]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    var updateMilestoneChangeLogSegmentsArray = [];
    for(let f = 0; f < numFieldsToUpdate; f++) {
      if(updateFieldTypeObjsArray[f] !== undefined) {
        const fieldDbName = updateFieldDbNamesArray[f];
        const newValue = updateNewValuesArray[f];
        const fieldDisplayName = updateFieldDisplayNamesArray[f];
        const fieldTypeObj = updateFieldTypeObjsArray[f];
        
        C_CallPhpTblUID.add_update("tbl_c_pm_proposal_milestones", i_expandedMilestoneObj.id, fieldDbName, newValue, fieldTypeObj.idsb);

        const newValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(newValue, fieldTypeObj);
        updateMilestoneChangeLogSegmentsArray.push(fieldDisplayName + " to '" + newValueMaskPlainText + "'");
      }
    }

    const updateMilestoneChangeLogString = "Updated Proposal Milestone '" + i_expandedMilestoneObj.milestone_name + "': set " + updateMilestoneChangeLogSegmentsArray.join(", ");
    C_CallPhpTblUID.add_changelog_details(i_expandedMilestoneObj.capture_id, k_cardIDProposalManagement, "um", "Update Milestone", updateMilestoneChangeLogString);

    C_CallPhpTblUID.execute();
  }

  a_ocpm_delete_milestone(i_expandedMilestoneObj) {
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_delete_milestone", ["i_expandedMilestoneObj"], [i_expandedMilestoneObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_c_pm_proposal_milestones", i_expandedMilestoneObj.id);
    C_CallPhpTblUID.add_changelog_details(i_expandedMilestoneObj.capture_id, k_cardIDProposalManagement, "dm", "Delete Milestone", "Deleted Proposal Milestone: '" + i_expandedMilestoneObj.milestone_name + "'");
    C_CallPhpTblUID.execute();
  }

  a_ocpm_delete_all_calendar_milestones() {
    const c_ocpmExpandedProposalObjOrUndefined = this.c_ocpmExpandedProposalObjOrUndefined;
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;
    const o_tbl_c_pm_proposal_milestones = DatabaseMobx.o_tbl_c_pm_proposal_milestones;

    if(c_ocpmExpandedProposalObjOrUndefined !== undefined) {
      const captureProposalMilestoneIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(o_tbl_c_pm_proposal_milestones, "capture_id", c_ocpmExpandedProposalObjOrUndefined.capture_id, "id");

      const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_delete_all_calendar_milestones", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_delete("tbl_c_pm_proposal_milestones", captureProposalMilestoneIDsToDeleteArray);
      C_CallPhpTblUID.add_changelog_details(c_ocpmExpandedProposalObjOrUndefined.capture_id, k_cardIDProposalManagement, "dam", "Delete All Calendar Milestones", "Deleted all calendar milestones for this proposal");
      C_CallPhpTblUID.execute();
    }
  }

  a_ocpm_apply_turnaround_template_to_open_proposal(i_turnaroundTemplateID) {
    const c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj = this.c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj;
    const c_ocpmExpandedProposalObjOrUndefined = this.c_ocpmExpandedProposalObjOrUndefined;
    const o_tbl_a_pm_all_milestones_pool = DatabaseMobx.o_tbl_a_pm_all_milestones_pool;
    const o_tbl_a_pm_milestones = DatabaseMobx.o_tbl_a_pm_milestones;
    const o_tbl_a_pm_sequences = DatabaseMobx.o_tbl_a_pm_sequences;
    const o_tbl_a_pm_turnaround_timeline_templates = DatabaseMobx.o_tbl_a_pm_turnaround_timeline_templates;
    const k_cardIDProposalManagement = DatabaseMobx.k_cardIDProposalManagement;

    if(c_ocpmExpandedProposalObjOrUndefined === undefined) {
      return;
    }

    const openCaptureID = c_ocpmExpandedProposalObjOrUndefined.capture_id;
    const openCaptureProposalDueDateTimeUtc = c_ocpmOpenCaptureProposalDueDateTimeUtcCaptureFieldValueObj.valueRaw;
    
    if(!JSFUNC.datetime_is_filled_out_tf(openCaptureProposalDueDateTimeUtc)) {
      return;
    }

    const openCaptureProposalDueDateUtcJsDateObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(openCaptureProposalDueDateTimeUtc);

    const matchingTurnaroundTemplateMapOrUndefined = JSFUNC.get_first_map_matching_field_value(o_tbl_a_pm_turnaround_timeline_templates, "id", i_turnaroundTemplateID);
    if(matchingTurnaroundTemplateMapOrUndefined === undefined) {
      return;
    }

    var matchingAdminSequencesWithMilestonesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_pm_sequences, "proposal_turnaround_timeline_template_id", i_turnaroundTemplateID, "sort", true);
    if(!JSFUNC.is_array_not_empty(matchingAdminSequencesWithMilestonesArrayOfObjs)) {
      return;
    }

    var numMilestonesToBeInserted = 0;
    for(let adminSequenceObj of matchingAdminSequencesWithMilestonesArrayOfObjs) {
      var matchingAdminMilestonesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(o_tbl_a_pm_milestones, "proposal_sequence_id", adminSequenceObj.id, "sort", true);
      adminSequenceObj.matchingAdminMilestonesArrayOfObjs = matchingAdminMilestonesArrayOfObjs;
      numMilestonesToBeInserted += matchingAdminMilestonesArrayOfObjs.length;
    }

    if(numMilestonesToBeInserted === 0) {
      return;
    }

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_ocpm_apply_turnaround_template_to_open_proposal", ["i_turnaroundTemplateID"], [i_turnaroundTemplateID]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    
    const fieldDbNamesArray = ["capture_id", "milestone_name", "milestone_styling_string_comma", "start_ce_datetime_utc", "end_ce_datetime_utc", "event_location", "event_participants_user_ids_comma", "notes"];
    const idsbArray = ["i", "s", "s", "s", "s", "s", "s", "s"];
    for(let adminSequenceObj of matchingAdminSequencesWithMilestonesArrayOfObjs) {
      for(let adminMilestoneObj of adminSequenceObj.matchingAdminMilestonesArrayOfObjs) {
        var poolMilestoneMapOrUndefined = o_tbl_a_pm_all_milestones_pool.get(adminMilestoneObj.proposal_milestone_pool_id);

        const startUtcJsDateObj = JSFUNC.jsdateobj_add_days(openCaptureProposalDueDateUtcJsDateObj, (-1 * adminMilestoneObj.initial_num_days_prior_to_proposal_due_date));
        const endUtcJsDateObj = JSFUNC.jsdateobj_add_days(startUtcJsDateObj, (adminMilestoneObj.initial_duration_num_days - 1));

        //initialize new milestone fields for insert
        var mName = "--Unnamed Milestone--";
        var mStylingStringComma = "";
        var mStartCEDatetimeUtcString = JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(startUtcJsDateObj, true) + " 00:00:58";
        var mEndCEDatetimeUtcString = JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(endUtcJsDateObj, true) + " 00:00:58";
        var mEventLocation = "";
        var mEventParticipantsUserIDsComma = "";
        var mNotes = "";
        if(poolMilestoneMapOrUndefined !== undefined) {
          //milestone name from the milestones pool
          mName = poolMilestoneMapOrUndefined.get("name");

          //merge milestone pool styling over any sequence styling
          var sequenceStylingObj = JSFUNC.convert_styling_tf_flags_and_colors_to_styling_obj(false, false, false, false, adminSequenceObj.sequence_bg_color);
          var poolMilestoneStylingObj = JSFUNC.convert_styling_string_comma_list_to_styling_obj(poolMilestoneMapOrUndefined.get("calendar_styling_string_comma"));
          var mergedSequencePoolStylingObj = JSFUNC.merge_styling_obj2_over_styling_obj1(sequenceStylingObj, poolMilestoneStylingObj);
          mStylingStringComma = JSFUNC.convert_styling_obj_to_styling_string_comma_list(mergedSequencePoolStylingObj);
        }

        const insertValuesArray = [openCaptureID, mName, mStylingStringComma, mStartCEDatetimeUtcString, mEndCEDatetimeUtcString, mEventLocation, mEventParticipantsUserIDsComma, mNotes];
        C_CallPhpTblUID.add_insert("tbl_c_pm_proposal_milestones", fieldDbNamesArray, insertValuesArray, idsbArray);
      }
    }

    C_CallPhpTblUID.add_changelog_details(c_ocpmExpandedProposalObjOrUndefined.capture_id, k_cardIDProposalManagement, "apt", "Apply Proposal Template", "Inserted " + numMilestonesToBeInserted + " milestone(s) from template '" + matchingTurnaroundTemplateMapOrUndefined.get("name") + "'");
    C_CallPhpTblUID.execute();
  }

  a_ocpm_set_selected_subtab_db_name(i_newValueString) {
    this.o_ocpmSelectedSubtabDbName = i_newValueString;
  }














  //Admin Proposal Management
  a_set_admin_setup_tab_proposal_management_options_selected_subtab_db_name(i_newValueString) {
    this.o_adminSetupTabProposalManagementOptionsSelectedSubtabDbName = i_newValueString;
  }


  a_apm_create_new_turnaround_template(i_newTurnaroundTemplateNameString) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_create_new_turnaround_template", ["i_newTurnaroundTemplateNameString"], [i_newTurnaroundTemplateNameString]);
    const C_CallPhpTblUIDInsertTurnaround = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const newTurnaroundInitialAdminSort = JSFUNC.sort_max_mysqli_int();;
    const fieldDbNamesArray = ["name", "admin_sort"];
    const valuesArray = [i_newTurnaroundTemplateNameString, newTurnaroundInitialAdminSort];
    const idsbArray = ["s", "i"];
    const resortSortColumnName = "admin_sort";
    const resortFilterFieldNameOrFieldNamesArray = [];
    const resortFilterValueOrValuesArray = [];
    C_CallPhpTblUIDInsertTurnaround.add_insert("tbl_a_pm_turnaround_timeline_templates", fieldDbNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedID = i_parseResponse.outputObj.i0;
      if(JSFUNC.is_number_not_nan_gt_0(newlyInsertedID)) {
        const newlyInsertedFakeExpandedTurnaroundObj = {id:newlyInsertedID};
        const injectedFirstSequenceDefaultName = i_newTurnaroundTemplateNameString + " Milestone Sequence";
        this.a_apm_create_new_sequence(newlyInsertedFakeExpandedTurnaroundObj, injectedFirstSequenceDefaultName);
      }
    }
    C_CallPhpTblUIDInsertTurnaround.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUIDInsertTurnaround.execute();
  }

  a_apm_update_turnaround_name(i_expandedTurnaroundObj, i_updatedTurnaroundName) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_update_turnaround_name", ["i_expandedTurnaroundObj", "i_updatedTurnaroundName"], [i_expandedTurnaroundObj, i_updatedTurnaroundName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_pm_turnaround_timeline_templates", i_expandedTurnaroundObj.id, ["name"], [i_updatedTurnaroundName], ["s"]);
    C_CallPhpTblUID.execute();
  }
  
  a_apm_delete_turnaround(i_expandedTurnaroundObj) {
    const o_apmSelectedSequenceIDOrUndefined = this.o_apmSelectedSequenceIDOrUndefined;

    //if the deleted turnaround has a currently selected sequence, set the selected sequence to undefined
    if(JSFUNC.in_array(o_apmSelectedSequenceIDOrUndefined, i_expandedTurnaroundObj.sequenceIDsArray)) {
      this.a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences(undefined);
    }

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_delete_turnaround", ["i_expandedTurnaroundObj"], [i_expandedTurnaroundObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_pm_milestones", i_expandedTurnaroundObj.allSequencesMilestoneIDsArray);
    C_CallPhpTblUID.add_delete("tbl_a_pm_sequences", i_expandedTurnaroundObj.sequenceIDsArray);
    C_CallPhpTblUID.add_delete("tbl_a_pm_turnaround_timeline_templates", i_expandedTurnaroundObj.id, "admin_sort", [], []);
    C_CallPhpTblUID.execute();
  }

  a_apm_create_new_sequence(i_parentExpandedTurnaroundObj, i_newSequenceNameString) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_create_new_sequence", ["i_parentExpandedTurnaroundObj", "i_newSequenceNameString"], [i_parentExpandedTurnaroundObj, i_newSequenceNameString]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const newSequenceInitialSort = JSFUNC.sort_max_mysqli_int();
    const fieldDbNamesArray = ["proposal_turnaround_timeline_template_id", "name", "sort", "sequence_bg_color"];
    const valuesArray = [i_parentExpandedTurnaroundObj.id, i_newSequenceNameString, newSequenceInitialSort, "88aa88"];
    const idsbArray = ["i", "s", "i", "s"];
    const resortSortColumnName = "sort";
    const resortFilterFieldNameOrFieldNamesArray = ["proposal_turnaround_timeline_template_id"];
    const resortFilterValueOrValuesArray = [i_parentExpandedTurnaroundObj.id];
    C_CallPhpTblUID.add_insert("tbl_a_pm_sequences", fieldDbNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedID = i_parseResponse.outputObj.i0;
      if(JSFUNC.is_number_not_nan_gt_0(newlyInsertedID)) {
        this.a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences(newlyInsertedID);
      }
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences(i_newValueIntOrUndefined) {
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;

    this.o_apmSelectedSequenceIDOrUndefined = i_newValueIntOrUndefined;

    //set calendar multiselect of selcted sequences to view
    var selectedShowSequenceIDsComma = "";
    if(JSFUNC.is_number_not_nan_gt_0(i_newValueIntOrUndefined)) { //not undefined
      for(let expandedTurnaroundObj of c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs) {
        if(JSFUNC.in_array(i_newValueIntOrUndefined, expandedTurnaroundObj.sequenceIDsArray)) {
          selectedShowSequenceIDsComma = JSFUNC.convert_array_to_comma_list(expandedTurnaroundObj.sequenceIDsArray);
          break;
        }
      }
    }
    this.o_apmCalendarPreviewSelectedShowSequenceIDsComma = selectedShowSequenceIDsComma;
  }

  a_apm_update_sequence_field(i_expandedSequenceObj, i_fieldDbName, i_newValue, i_idsb) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_update_sequence_field", ["i_expandedSequenceObj", "i_fieldDbName", "i_newValue", "i_idsb"], [i_expandedSequenceObj, i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_pm_sequences", i_expandedSequenceObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }
  
  a_apm_delete_sequence(i_expandedSequenceObj) {
    const o_apmSelectedSequenceIDOrUndefined = this.o_apmSelectedSequenceIDOrUndefined;

    //if the deleted sequence was selected, set the selected sequence to undefined
    if(i_expandedSequenceObj.id === o_apmSelectedSequenceIDOrUndefined) {
      this.a_apm_set_selected_sequence_id_or_undefined_and_set_calendar_selected_sequences(undefined);
    }

    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_delete_sequence", ["i_expandedSequenceObj"], [i_expandedSequenceObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_pm_milestones", i_expandedSequenceObj.milestoneIDsArray);
    C_CallPhpTblUID.add_delete("tbl_a_pm_sequences", i_expandedSequenceObj.id, "sort", ["proposal_turnaround_timeline_template_id"], [i_expandedSequenceObj.proposal_turnaround_timeline_template_id]);
    C_CallPhpTblUID.execute();
  }

  a_apm_add_pool_milestone_to_sequence(i_selectedExpandedSequenceObj, i_allMilestonesPoolID) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_add_pool_milestone_to_sequence", ["i_selectedExpandedSequenceObj", "i_allMilestonesPoolID"], [i_selectedExpandedSequenceObj, i_allMilestonesPoolID]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const fieldDbNamesArray = ["proposal_sequence_id", "proposal_milestone_pool_id", "initial_num_days_prior_to_proposal_due_date", "initial_duration_num_days"];
    const valuesArray = [i_selectedExpandedSequenceObj.id, i_allMilestonesPoolID, 0, 1];
    const idsbArray = ["i", "i", "i", "i"];
    C_CallPhpTblUID.add_insert("tbl_a_pm_milestones", fieldDbNamesArray, valuesArray, idsbArray);

    C_CallPhpTblUID.execute();
  }

  a_apm_update_milestone_field(i_expandedMilestoneObj, i_fieldDbName, i_newValue, i_idsb) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_update_milestone_field", ["i_expandedMilestoneObj", "i_fieldDbName", "i_newValue", "i_idsb"], [i_expandedMilestoneObj, i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update("tbl_a_pm_milestones", i_expandedMilestoneObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }

  a_apm_remove_milestone_from_sequence(i_expandedMilestoneObj) {
    const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_remove_milestone_from_sequence", ["i_expandedMilestoneObj"], [i_expandedMilestoneObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_delete("tbl_a_pm_milestones", i_expandedMilestoneObj.id); //no resorting to do, milestones are sorted by their days prior number
    C_CallPhpTblUID.execute();
  }

  a_apm_remove_all_milestones_matching_milestone_pool_ids_from_sequences(i_successfullyDeletedPoolMilestoneRowIDsArray) {
    const c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs = this.c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs;
    
    //loop through every turnaround/sequence/milestone to determine which milestones used any of the input deleted pool milestone ids
    var milestoneIDsToDeleteArray = [];
    for(let expandedTurnaroundObj of c_apmAllExpandedTurnaroundsSequencesMilestonesArrayOfObjs) {
      for(let expandedSequenceObj of expandedTurnaroundObj.expandedSequencesArrayOfObjs) {
        for(let expandedMilestoneObj of expandedSequenceObj.expandedMilestonesArrayOfObjs) {
          if(JSFUNC.in_array(expandedMilestoneObj.proposal_milestone_pool_id, i_successfullyDeletedPoolMilestoneRowIDsArray)) {
            milestoneIDsToDeleteArray.push(expandedMilestoneObj.id);
          }
        }
      }
    }

    if(milestoneIDsToDeleteArray.length > 0) {
      const jsDescription = JSFUNC.js_description_from_action("ProposalManagementMobx", "a_apm_remove_all_milestones_matching_milestone_pool_ids_from_sequences", ["i_successfullyDeletedPoolMilestoneRowIDsArray"], [i_successfullyDeletedPoolMilestoneRowIDsArray]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_delete("tbl_a_pm_milestones", milestoneIDsToDeleteArray); //can remove multiple milestones from multiple mixed sequences because there is no resorting to do, milestones are sorted by their days prior number
      C_CallPhpTblUID.execute();
    }
  }

  a_apm_set_calendar_preview_selected_show_sequence_ids_comma(i_newValueString) {
    this.o_apmCalendarPreviewSelectedShowSequenceIDsComma = i_newValueString;
  }

  a_apm_set_calendar_preview_display_num_weeks(i_newValueInt) {
    this.o_apmCalendarPreviewDisplayNumWeeks = i_newValueInt;
  }

  a_apm_set_calendar_preview_week_height(i_newValueInt) {
    this.o_apmCalendarPreviewWeekHeight = i_newValueInt;
  }
  
}
export default new ProposalManagementMobx();
